"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyCustomerByCustomerNumberResponseMatchesToJSON = exports.IdentifyCustomerByCustomerNumberResponseMatchesFromJSONTyped = exports.IdentifyCustomerByCustomerNumberResponseMatchesFromJSON = void 0;
var runtime_1 = require("../runtime");
function IdentifyCustomerByCustomerNumberResponseMatchesFromJSON(json) {
    return IdentifyCustomerByCustomerNumberResponseMatchesFromJSONTyped(json, false);
}
exports.IdentifyCustomerByCustomerNumberResponseMatchesFromJSON = IdentifyCustomerByCustomerNumberResponseMatchesFromJSON;
function IdentifyCustomerByCustomerNumberResponseMatchesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerNo': json['customerNo'],
        'dateOfBirth': !(0, runtime_1.exists)(json, 'dateOfBirth') ? undefined : (new Date(json['dateOfBirth'])),
        'match': json['match'],
    };
}
exports.IdentifyCustomerByCustomerNumberResponseMatchesFromJSONTyped = IdentifyCustomerByCustomerNumberResponseMatchesFromJSONTyped;
function IdentifyCustomerByCustomerNumberResponseMatchesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerNo': value.customerNo,
        'dateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString().substr(0, 10)),
        'match': value.match,
    };
}
exports.IdentifyCustomerByCustomerNumberResponseMatchesToJSON = IdentifyCustomerByCustomerNumberResponseMatchesToJSON;
//# sourceMappingURL=IdentifyCustomerByCustomerNumberResponseMatches.js.map